import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const myAgentReducer = (state = initialState.myAgent, action) => {
  switch (action.type) {
    case types.FETCH_MY_AGENT_STARTED:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case types.FETCH_MY_AGENT_SUCCEEDED:
      return {
        ...state,
        agentData: action.payload,
        isLoading: false
      };
    case types.FETCH_MY_AGENT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default myAgentReducer;
